import axios from "axios";

export const TOKEN_KEY = "et_admin_token";

export const adminApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

adminApi.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

adminApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && !String(e.config?.url).includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith("/admin/login")) window.location.assign("/admin/login");
    }
    return Promise.reject(e);
  }
);
